import { BaseApiService } from './BaseApiService';

class RemoteCallService extends BaseApiService {
    async getSlotsByInterviewer(interviewerId, page = 1, perPage = 10) {
    try {
      console.log('Making API call to get slots by interviewer...', { interviewerId, page, perPage });
   
      const response = await this.api.post('/v1/get-slots-by-interviewer', {
        interviewer_id: interviewerId,
        page: page,
        per_page: perPage,
      });
   
      console.log('Get slots by interviewer response:', response.data);
      return response.data;
    } catch (error) {
      console.error('Get slots by interviewer error:', error);
      throw error;
    }
  }
  
  

  async getMeetingLinkStatus() {
    try {
      console.log('Making API call to get meeting link status...');
      const response = await this.api.get('/v1/meetinglink-status');
      console.log('Get meeting link status response:', response.data);
      return response.data;
    } catch (error) {
      console.error('Get meeting link status error:', error);
      throw error;
    }
  }

  async storeMeetingLink(slotId, meetingLink) {
    try {
      console.log('Making API call to store meeting link...', { 
        slotId, 
        meetingLink,
        slotIdType: typeof slotId,
        isSlotIdValid: slotId !== null && slotId !== undefined && slotId !== ''
      });
      
      // Validate inputs before sending
      if (!slotId || slotId === '' || slotId === null || slotId === undefined) {
        throw new Error('Slot ID is missing or invalid');
      }
      
      if (!meetingLink || meetingLink.trim() === '') {
        throw new Error('Meeting link is missing or invalid');
      }
      
      const response = await this.api.post('/v1/store-meetinglink', {
        slot_id: slotId,
        meeting_link: meetingLink
      });
      console.log('Store meeting link response:', response.data);
      return response.data;
    } catch (error) {
      console.error('Store meeting link error:', {
        error: error.message,
        response: error.response?.data,
        status: error.response?.status,
        slotId,
        meetingLink
      });
      throw error;
    }
  }
}

export const remoteCallService = new RemoteCallService();